export class EditLobbyComment {
    commentId: number = 0;
    comment: string = '';
    editeById:number = 0;
}
